import type {ChatMessage, ModelMessage} from '@Components/ai-chat-window/ai-chat-window.types';
import type {GeneratedImagePartActionsProps} from '@Components/ai-chat-window/components/generated-image/generated-image.types';

export interface GeneratedImageIconsProps extends GeneratedImagePartActionsProps {
  chatId: string;
  hashedId: string;
  isMobile?: boolean;
  isLastMessage: boolean;
  isVisible?: boolean;
  onThumbsUp?: VoidFunction;
  onThumbsDown?: (reason: string) => void;
  message: ModelMessage;
  messages: Record<string, ChatMessage>;
  isMessageStreaming?: boolean;
  hasLayeredPoster: boolean;
  isCompact: boolean;
}

export enum ChatImageActionPanelId {
  NEGATIVE_FEEDBACK_DROPDOWN_MODAL_PANEL_ID = 'chat-image-negative-feedback-dropdown-modal-panel-id',
  PUBLISH_OPTIONS_DROPDOWN_MODAL_PANEL_ID = 'chat-image-publish-options-dropdown-modal-panel-id',
  MORE_OPTIONS_DROPDOWN_MODAL_PANEL_ID = 'chat-image-more-options-dropdown-modal-panel-id',
  CHANGE_STYLE_DROPDOWN_MODAL_PANEL_ID = 'chat-image-change-style-dropdown-modal-panel-id',
}
